import type { ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';

interface CardProps {
  children: ReactNode;
  className?: string;
}

export function Card({ children, className }: CardProps) {
  return <section className={cn('overflow-hidden rounded-card border border-line bg-surface shadow-card', className)}>{children}</section>;
}

export function CardHeader({ children, className }: CardProps) {
  return <header className={cn('flex flex-wrap items-center justify-between gap-3 border-b border-line px-5 py-4', className)}>{children}</header>;
}

export function CardFooter({ children, className }: CardProps) {
  return (
    <footer className={cn('flex flex-wrap items-center justify-between gap-3 border-t border-line bg-surface-muted/60 px-5 py-3.5', className)}>
      {children}
    </footer>
  );
}
